// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"551":"4fa3bd53","629":"4fa3bd53"}[chunkId] + ".chunk.css";
};